<template>
  <div id="invoice">
    <div class="invoice_box">
      <div class="form_box">
        <el-form
          class="ser_form"
          ref="detailForm"
          label-position="right"
          label-width="130px"
          :hide-required-asterisk="true"
          :model="detailForm"
          :rules="rules"
        >
          <el-form-item class="s_form_t" label="手机号" prop="phone">
            <el-input
              class="inlineInput"
              v-model.trim="detailForm.phone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <el-form-item class="s_form_t" label="图形验证码" prop="validateCode">
            <el-input
              class="codeinput"
              v-model="detailForm.validateCode"
              placeholder="请输入图形验证码"
            ></el-input>
            <div class="code_box">
              <img style="width: 100%;height: 40px;" :src="codeImg" @click="getCodeImg()" ref="code" alt="">
            </div>
          </el-form-item>

          <el-form-item class="s_form_t" label="短信验证码" prop="code">
            <el-input
              class="codeinput"
              v-model="detailForm.code"
              placeholder="请输入短信验证码"
            ></el-input>
            <div class="code_box">
              <el-button class="codebtn" style="height:40px" type="primary" :disabled="disabled" @click="getVerifyCode()">{{btnTitle}}</el-button>
            </div>
          </el-form-item>

          <el-form-item class="s_form_t" label="新密码" prop="newpwd">
            <el-input
              class="inlineInput"
              show-password
              v-model="detailForm.newpwd"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div class="certbtn_box">
        <el-button
          class="certbtn"
          type="primary"
          @click="submitFormlogin('detailForm')"
          >提交</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Qs from "qs";
import { sesStorage } from "@/model/storage.js";
import  config  from '@/model/config.js'

export default {
  data() {
    var phonerule = (rule, value, callback) => {
      const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      btnTitle: "获取验证码",
      disabled: false, //是否可点击
      codeImg:'',
      detailForm: {
        phone: "",
        newpwd: "",
        code: "",
        validateCode: ""
      },
      rules: {
        phone: [{ required: true, validator: phonerule, trigger: "blur" }],
        newpwd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
        validateCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
      },
    };
  },
  components: {},
  methods: {
    submitFormlogin(formName) {
      let param={
        phone :this.detailForm.phone,
        code :this.detailForm.code,
        newpwd :this.detailForm.newpwd
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .post("/front/user/wjPassword", Qs.stringify(param))
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                  center: true,
                });
                this.$parent.$emit('update:visible',false);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                  center: true,
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    // 获取短信验证码
    getVerifyCode() {
      if (this.validatePhone()) {
        this.validateBtn();
        let param={
          phone:this.detailForm.phone,
          validateCode:this.detailForm.validateCode
        }
        this.$http
            .post("/front/user/yanzhengma", Qs.stringify(param))
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                  center: true,
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                  center: true,
                });
              }
            });
      }
    },
    validateBtn() {
      //倒计时
      let time = 60;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.disabled = false;
          this.btnTitle = "获取验证码";
        } else {
          this.btnTitle = time + "秒后重试";
          this.disabled = true;
          time--;
        }
      }, 1000);
    },
    validatePhone() {
      //判断输入的手机号是否合法
      if (!this.detailForm.phone) {
        this.$message.error("手机号码不能为空");
        return false;
      } else if (!/^1[345678]\d{9}$/.test(this.detailForm.phone)) {
        this.$message.error("请输入正确是手机号");
        return false;
      }else if (!this.detailForm.validateCode) {
        this.$message.error("请输入图形验证码");
        return false;
      } else {
        return true;
      }
    },
    //  获取图形验证码
    getCodeImg(){
      this.$refs.code.src=config.URL+'/captcha/captchaImage?type=math&d=' + new Date().getTime()
    }
  },
  mounted() {
    this.getCodeImg()
  },
  watch: {},
};
</script>


<style lang="scss" scoped>
#invoice {
  .ser_form {
    & >>> .el-form-item__label {
      font-size: 16px;
      font-weight: bold;
      color: #303643;
    }
    & >>> .el-input__inner::placeholder {
      color: #999;
    }
  }
  .form_box {
    margin: 0 auto;
    width: 560px;
  }
  .s_form_t {
    & >>> .el-form-item__label {
      font-size: 14px;
    }
  }
  .inlineInput {
    width: 300px;
    & >>> .el-input__inner {
      width: 300px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
    & >>> .el-select__caret {
      color: #303643;
    }
    & >>> .el-date-editor.el-input,
    & >>> .el-date-editor.el-input__inner {
      width: 300px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
  }
  .codeinput{
    width: 160px;
    float: left;
    & >>> .el-input__inner {
      width: 160px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
    & >>> .el-select__caret {
      color: #303643;
    }
    & >>> .el-date-editor.el-input,
    & >>> .el-date-editor.el-input__inner {
      width: 160px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
  }

  .certbtn_box {
    width: 120px;
    margin: 42px auto 10px auto;
  }
  .code_box{
    width: 120px;
    margin-left: 16px;
    float: left;
    height: 40px;
  }
  .certbtn {
    height: 42px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 100%;
  }
  .codebtn{
    height: 40px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 100%;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/forgetPass.vue